import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

export default function MultiSelect({
  options,
  placeholder,
  error,
  helperText,
  label,
  id,
  limitTags,
  onChange,
  value,
  isArr = false
}) {
  const isValueArray = Array.isArray(value);
  return (
    <Autocomplete
      multiple
      limitTags={limitTags}
      id={id}
      options={options}
      value={value}
      onChange={(_, selectedOptions) => {
        // Convert selected objects => comma-separated string
        const values = selectedOptions.map((opt) => opt.value);
        const selected = isArr? values : values.join(", ");
        // isArr ? console.log(selectedOptions) : console.log("not arr");
        onChange(selected);
      }}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      filterSelectedOptions
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
}
